import Cookies from 'js-cookie';
import {
  PartnerCookieData,
  PARTNER_COOKIE_NAME,
  PARTNER_COOKIE_EXPIRATION_HOURS,
  getCookieDomain,
  DEV_MODE,
} from './util';
import { DateTime } from 'luxon';

export default function setPartnerCookie(isPartner: boolean) {
  const data: PartnerCookieData = { isPartner };
  Cookies.set(PARTNER_COOKIE_NAME, JSON.stringify(data), {
    expires: DateTime.utc().plus({ hours: PARTNER_COOKIE_EXPIRATION_HOURS }).toJSDate(),
    domain: getCookieDomain(),
    secure: !DEV_MODE,
  });
}
